module.exports = __webpack_public_path__ + "media/game-start-countdown.b9ed6375.mp3";